export function compareStrings(strA, strB, ignoreCase = false) {
  if (!strA && !strB) return 0;
  if (!strA) return -1;
  if (!strB) return 1;

  const a = ignoreCase ? strA.toLowerCase() : strA;
  const b = ignoreCase ? strB.toLowerCase() : strB;

  if (a < b) {
    return -1;
  }
  if (a > b) {
    return 1;
  }
  return 0;
}

export function getValueFromObjByString(prop, obj) {
  let result = obj;
  const props = prop.split(".");

  props.forEach(key => {
    result = result[key];
  });

  return result;
}

export function sortByObjectProp(array, prop) {
  if (!array) return [];
  if (!prop) return array;

  const list = [].concat(array);
  let aProp;
  let bProp;

  const compare = (a, b) => {
    aProp = getValueFromObjByString(prop, a);
    bProp = getValueFromObjByString(prop, b);

    return compareStrings(aProp, bProp, true);
  };

  return list.sort(compare);
}

export function sortAttributes(attributeA, attributeB) {
  const nameA = attributeA.displayName || attributeA.name;
  const nameB = attributeB.displayName || attributeB.name;

  return compareStrings(nameA, nameB, true);
}
